interface ILinks {
  home: string;
  updates: string;
  prabhupada: string;
  donate: string;

  login: string;
  forgotPassword: string;
  forgotPasswordSuccess: string;
  createNewPassword: string;
  createNewPasswordSuccess: string;
}

const links: ILinks = {
  home: '/',
  updates: '/updates',
  prabhupada: '/prabhupada',
  donate: '/donate',

  login: '/login',
  forgotPassword: '/forgot-password',
  forgotPasswordSuccess: '/forgot-password-success',
  createNewPassword: '/create-new-password',
  createNewPasswordSuccess: '/create-new-password-success',
};

export default links;
